// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oq7x","label":"styles_label__1bIrW"};